//----------------------------------------------------------------------------
// THIS IS A GENERATED REACT ICON COMPONENT. DO NOT EDIT MANUALLY AT ANY COST!
//----------------------------------------------------------------------------;

import type { IconProps } from "../../types/icon";
import { IconWrapper } from "../IconWrapper";

export const Trashcan = (allProps: IconProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IconWrapper
      componentName="Trashcan"
      icon={
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <g clipPath="url(#prefix__clip0_21705_3458)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.8405 5.33332L13.3832 14.48H13.3831C13.3405 15.3313 12.6385 15.9993 11.7865 16H4.21314C3.36114 15.9993 2.65847 15.3307 2.61647 14.4793L2.15914 5.33332H2.13314C1.2498 5.33332 0.533142 4.61666 0.533142 3.73333C0.533142 2.84999 1.2498 2.13333 2.13314 2.13333H4.92387L5.17721 1.18533C5.36522 0.485341 5.99987 -0.000665938 6.72387 0H9.29991C10.0346 0 10.6746 0.499336 10.8526 1.212L11.0826 2.13333H13.8665C14.7498 2.13333 15.4665 2.84999 15.4665 3.73333C15.4665 4.61666 14.7498 5.33332 13.8665 5.33332H13.8405ZM6.72387 1.06675C6.48321 1.06675 6.27187 1.22875 6.20921 1.46142L6.0265 2.13341H9.98391L9.81791 1.47075C9.75857 1.23342 9.54524 1.06675 9.2999 1.06675H6.72387ZM2.13318 3.19999C1.83851 3.19999 1.59985 3.43865 1.59985 3.73333C1.59985 4.028 1.83851 4.26666 2.13318 4.26666H13.8665C14.1612 4.26666 14.3998 4.028 14.3998 3.73333C14.3998 3.43865 14.1612 3.19999 13.8665 3.19999H2.13318ZM3.22727 5.33332L3.67993 14.4266H3.68002C3.69401 14.7106 3.92868 14.9339 4.21335 14.9333H11.7867C12.0707 14.934 12.3053 14.7113 12.32 14.4273L12.774 5.33332H3.22727ZM10.3078 7.60398C10.4131 7.50865 10.5518 7.45932 10.6931 7.46665C10.8345 7.47331 10.9678 7.53664 11.0625 7.64131C11.1578 7.74664 11.2071 7.88531 11.1998 8.02664L10.9865 12.2933C10.9718 12.588 10.7211 12.8146 10.4265 12.8C10.1318 12.7853 9.90513 12.5347 9.9198 12.24L10.1331 7.97332C10.1398 7.83198 10.2031 7.69865 10.3078 7.60398ZM5.30655 7.46665C5.16522 7.47332 5.03188 7.53665 4.93721 7.64131C4.84188 7.74664 4.79254 7.88531 4.79988 8.02664L5.01321 12.2933C5.03188 12.586 5.28054 12.8106 5.5732 12.8C5.71453 12.7933 5.84787 12.73 5.94254 12.6253C6.03787 12.52 6.0872 12.3813 6.07987 12.24L5.86654 7.97332C5.85054 7.67932 5.60054 7.45332 5.30655 7.46665ZM7.46651 7.99998C7.46651 7.70531 7.70516 7.46665 7.99984 7.46665L7.99984 7.46666C8.14117 7.46666 8.27717 7.52265 8.37717 7.62265C8.47717 7.72265 8.53317 7.85865 8.53317 7.99998V12.2666C8.53317 12.5613 8.29451 12.8 7.99984 12.8C7.70516 12.8 7.46651 12.5613 7.46651 12.2666V7.99998Z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath
              style={{
                visibility: "visible",
                display: "block"
              }}
              id="prefix__clip0_21705_3458"
            >
              <rect width={16} height={16} fill="white" />
            </clipPath>
          </defs>
        </svg>
      }
      {...restProps}
    />
  );
};
